import { useContext, useEffect, useRef, useState } from 'react';
import { Client } from "@stomp/stompjs";
import { Card } from '@mui/material';
import { FileImportProcessContext } from '../../../context/fileImportProcessContext';
import { IUploadedFile } from '../../../interfaces/fileimport';
import styles from './styles';
import SubscribingComponent from './subscribing-component';
import { WEB_SOCKET_DOMAIN } from '../../../utility/constants';

export interface FileImportLoaderProps {
  content: string;
  link: string;
  show: boolean;
  newDocuments: IUploadedFile[];
}

/**
 * A component for rendering the file import loader.
 * @param props The props to configure the component.
 * @returns The rendered ImportFileLoader component.
 */
const ImportFileLoader = (props: FileImportLoaderProps) => {
  const { state, dispatch } = useContext(FileImportProcessContext);

  const [arConnected, setArConnected] = useState<boolean>(false);
  const [invConnected, setInvConnected] = useState<boolean>(false);
  const arClientRef = useRef<Client | null>(null);
  const invClientRef = useRef<Client | null>(null);

  useEffect(() => {
    const client = new Client({
      webSocketFactory: () => new WebSocket(`${WEB_SOCKET_DOMAIN}/calc`),
      reconnectDelay: 5000,
      debug: () => {}, // Disable noisy logs; add `console.log` if needed
    });

    client.onConnect = (frame) => {
      setArConnected(true);
    };

    client.onStompError = (frame) => {
      console.error('❌ STOMP error:', frame.headers['message'], frame.body);
    };

    client.onWebSocketError = (error) => {
      console.error('❌ WebSocket error:', error);
    };

    client.activate();
    arClientRef.current = client;

    return () => {
      client.deactivate();
      setArConnected(false);
    };
  }, []);

  useEffect(() => {
    const client = new Client({
      webSocketFactory: () => new WebSocket(`${WEB_SOCKET_DOMAIN}/inventory-ws`),
      reconnectDelay: 5000,
      debug: () => {}, // Disable noisy logs; add `console.log` if needed
    });

    client.onConnect = (frame) => {
      setInvConnected(true);
    };

    client.onStompError = (frame) => {
      console.error('❌ STOMP error:', frame.headers['message'], frame.body);
    };

    client.onWebSocketError = (error) => {
      console.error('❌ WebSocket error:', error);
    };

    client.activate();
    invClientRef.current = client;

    return () => {
      client.deactivate();
      setInvConnected(false);
    };
  }, []);

  return (
    <Card variant="outlined" sx={state.hideOnly ? styles.hidden : styles.container}>
      {arConnected && invConnected && <SubscribingComponent
        state={state}
        dispatch={dispatch}
        stompClient={{
          arClient: arClientRef.current,
          invClient: invClientRef.current
        }}
        {...props}
      />}
    </Card>
  )
}

export default ImportFileLoader;